export default {
  getDataChat: state => state.dataChat,
  getShowCurrentChat: state => state.showCurrentChat
}
